// @flow

const environmentTypes = {
  DEVELOPMENT: "development",
  PRODUCTION: "production"
};

const serverEnvironments = {
  DEVELOPMENT: "development",
  INTEGRATION: "integration",
  STAGING: "staging",
  BETA: "beta",
  PRODUCTION: "production"
};

export const ENVIRONMENT = "ENVIRONMENT";
export const ROLLBAR_TOKEN = "ROLLBAR_TOKEN";
export const SERVER_ENVIRONMENT = "SERVER_ENVIRONMENT";

export const OKP_OAUTH_URL = "OKP_OAUTH_URL";
export const BUBA_API_AUTH_URL = "BUBA_API_AUTH_URL";
export const BUBA_API_URL = "BUBA_API_URL";
export const BUBA_API_URL_V2 = "BUBA_API_URL_V2";
export const CUSTOMER_PORTAL_URL = "CUSTOMER_PORTAL_URL";
export const CUSTOMER_INQUIRY_URL = "CUSTOMER_INQUIRY_URL";
export const CONSULTANT_INQUIRY_URL = "CONSULTANT_INQUIRY_URL";
export const CONSULTANT_INQUIRY_HOSTNAME = "CONSULTANT_INQUIRY_HOSTNAME";
export const CONSULTANT_PORTAL_QUERY_PARAM = "CONSULTANT_PORTAL_QUERY_PARAM";
export const BANK_PORTAL_URL = "BANK_PORTAL_URL";
export const BANK_INQUIRY_URL = "BANK_INQUIRY_URL";
export const LEASING_PORTAL_URL = "LEASING_PORTAL_URL";
export const LEASING_INQUIRY_URL = "LEASING_INQUIRY_URL";
export const OKP_INQUIRY_URL = "OKP_INQUIRY_URL";
export const BAPI_CLIENT_ID = "BAPI_CLIENT_ID";
export const INACTIVITY_TIMEOUT = "INACTIVITY_TIMEOUT";
export const ACCEPT_COOKIE = "ACCEPT_COOKIE";
export const ETRACKER_ID = "ETRACKER_ID";

const defaults = {
  [ENVIRONMENT]: process.env.NODE_ENV,
  [SERVER_ENVIRONMENT]: serverEnvironments.DEVELOPMENT,
  [BUBA_API_AUTH_URL]:
    process.env.REACT_APP_BUBA_API_AUTH_URL || "https://be.staging.buba.finstreet.app/api",
  [BUBA_API_URL]:
    process.env.REACT_APP_BUBA_API_URL || "https://be.staging.buba.finstreet.app/api/v1",
  [BUBA_API_URL_V2]:
    process.env.REACT_APP_BUBA_API_URL_V2 || "https://be.staging.buba.finstreet.app/api/v2",
  [CUSTOMER_PORTAL_URL]: "https://staging.buba.finstreet.app/kundenportal",
  [CUSTOMER_INQUIRY_URL]: "https://staging.buba.finstreet.app/kundenanfrage",
  [CONSULTANT_INQUIRY_URL]: "https://staging.buba.finstreet.app/berateranfrage",
  [CONSULTANT_INQUIRY_HOSTNAME]: "/berateranfrage",
  [CONSULTANT_PORTAL_QUERY_PARAM]: "art=berater",
  [BANK_PORTAL_URL]: "https://staging.buba.finstreet.app/bankportal",
  [BANK_INQUIRY_URL]: "https://staging.buba.finstreet.app/bankanfrage",
  [LEASING_PORTAL_URL]: "https://staging.buba.finstreet.app/leasingportal",
  [LEASING_INQUIRY_URL]: "https://staging.buba.finstreet.app/leasinginquiry",
  [OKP_INQUIRY_URL]: "https://staging.buba.finstreet.app/VR-Anfrage",
  [BAPI_CLIENT_ID]: "",
  [INACTIVITY_TIMEOUT]: "60", // minutes,
  [ACCEPT_COOKIE]: "opt-in",
  [ETRACKER_ID]: "5dVHpV",
  [ROLLBAR_TOKEN]: "placeholder_token"
};

// $FlowFixMe
export const getEnvironmentVariable = variable =>
  process.env[`REACT_APP_${variable}`] || defaults[variable];

export const isDevelopment = () =>
  getEnvironmentVariable(ENVIRONMENT) === environmentTypes.DEVELOPMENT;

export const isProduction = () =>
  getEnvironmentVariable(ENVIRONMENT) === environmentTypes.PRODUCTION;

export const rollbarConfig = {
  accessToken: getEnvironmentVariable(ROLLBAR_TOKEN),
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: getEnvironmentVariable(SERVER_ENVIRONMENT),
  scrubTelemetryInputs: true
};
